import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { switchMap, catchError, tap, filter, take, map } from 'rxjs/operators';
import { AuthState } from '../store';

import * as fromStore from '../store';
import * as fromRoot from '../../store';

export const AuthGuard: CanActivateFn = () => {
  const store = inject(Store<AuthState>);

  return combineLatest([
    store.select(fromStore.getAuthSignedIn),
    store.select(fromStore.getAuthChecked),
    store.select(fromStore.getAuthChecking),
    store.select(fromRoot.getRouterState),
  ])
    .pipe(
      tap(([signedIn, checked, checking, route]) => {
        if (!checked && !checking) {
          store.dispatch(fromStore.CheckAuth());
          return;
        }
        if (checked && !signedIn) {
          store.dispatch(fromRoot.Go({ path: ['/instellingen'], queryParams: { returnUrl: route.state.url } }));
        }
      }),
      map(([signedIn, checked, checking]) => signedIn && checked && !checking),
      filter(loaded => loaded),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
